module.exports = __webpack_public_path__ + "img/sidebar_superleague_202627.35cecd4b.png";